import React,{useState,useRef,useEffect} from "react";
import { Link,useHistory} from "react-router-dom";
import Footer from '../Global/Footer';
import Header from '../Global/Header';
import { Path,setting_table_id,bucketName,dirName,region,accessKeyId,secretAccessKey } from './../Path.js';
import { DataStore,Predicates } from '@aws-amplify/datastore';
import {Users} from './../models';
import { Amplify, API, graphqlOperation } from 'aws-amplify';
import awsconfig from './../aws-exports1';
var md5 = require('md5');
// Amplify.configure(awsconfig);
// const config = {
//     bucketName: bucketName,
//     dirName: dirName, /* optional */
//     region: region,
//     accessKeyId: accessKeyId,
//     secretAccessKey: secretAccessKey,
// }
function Register(){
    let history = useHistory();
    const name = useRef(null);
    const email = useRef(null);
    const password = useRef(null);
    const cpassword = useRef(null);
    const [Opacity, setOpacity] = useState('1');
	const [PointerEvents, setPointerEvents] = useState('');
    const [notification, setNotification] = useState({success:'',failed:'',show_success:false,show_failed:false});
	const [Loader, setLoader] = useState(false);
	const [errors, setErrors] = useState('');
    const handleValidation=()=>{
        let formIsValid = false;
          if(name.current.value===''){
            setErrors('Please enter name!!');		   
          }else if(email.current.value===''){
            setErrors('Please enter email-id!!');	
          }else if(password.current.value===''){
            setErrors('Please enter password!!');	
          }else if(cpassword.current.value===''){
            setErrors('Please confirm your password!!');	
          }else if(password.current.value!==cpassword.current.value){
            setErrors('Password and confirm password does not matched!!');	
          }else {
            setErrors('');
            formIsValid = true;
          }	
        return formIsValid;
    }
    const hide_notification=()=>{
        setNotification({sucess:'',failed:'',show_failed:false,show_success:false});
        setErrors('');
    }
    const add_data= async(event)=>{
        event.preventDefault();
        if(handleValidation()){	
            setLoader(true);
            setOpacity('0.5');
            setPointerEvents('none');
            await DataStore.save(
                new Users({
                    "name": name.current.value,
                    "email": email.current.value,
                    "password": md5(password.current.value),
                })
            ).then((data)=>{
                name.current.value='';
                email.current.value='';
                password.current.value='';
                cpassword.current.value='';
                setLoader(false);
                setOpacity('');
                setPointerEvents('');
                setNotification({success:'You are registered successfully.',failed:'',show_failed:false,show_success:true});
                setErrors('');	
                setTimeout(hide_notification, 4000);
            }).catch((err)=>{
                setNotification({success:'',failed:err,show_failed:true,show_success:false});
                setTimeout(hide_notification, 4000);
                setErrors('');
            })    
        }
    }

return(
<>
<Header />
<div className="container-fluid auth-bg">
    <div className="row">
    <h2 className='why-head heading'>Get Registerd yourself at $LITTLE</h2>
        
        
    <div className="col-md-2">
            
            </div>
             <center>
            <div className="col-md-12">
            <form className="form-horizontal auth" onSubmit={add_data}>

  
                        <div className="form-group">
                            <label className="col-lg-3 control-label">Name:</label>
                            <div className="col-lg-8">
                            <input className="form-control" type="text" ref={name}/>
                            </div>
                        </div>
                        <div className="form-group">
                            <label className="col-lg-3 control-label">Email:</label>
                            <div className="col-lg-8">
                            <input className="form-control" type="email" ref={email} />
                            </div>
                        </div>
                        <div className="form-group">
                            <label className="col-md-3 control-label">Password:</label>
                            <div className="col-md-8">
                            <input className="form-control" type="password" ref={password} />
                            </div>
                        </div>
                        <div className="form-group">
                            <label className="col-md-3 control-label">Confirm password:</label>
                            <div className="col-md-8">
                            <input className="form-control" type="password" ref={cpassword} />
                            </div>
                        </div>
                        {notification.show_success ? (<div className="alert alert-success" id="success2">{notification.success}
                        <button type="button" className="close" data-dismiss="alert"></button>
                        </div>) : ('')}		
                        {notification.show_failed ? (<div className="alert alert-danger" id="danger2">{notification.failed}
                            <button type="button" className="close" data-dismiss="alert"></button>
                        </div>) : ('')}
                        {errors ?(<div className="alert alert-danger" style={{color: "#721c24"}}>{errors}</div>):('')}
                        <div className="form-group">
                            <label className="col-md-3 control-label"></label>
                            <div className="col-md-8 btn-block auth">
                            
                            {/* <input type="button" className="custom-btn btn-banner" defaultValue="Save Changes" /> */}

                            <button className="custom-btn btn-banner" onClick={add_data} style={{opacity:Opacity,pointerEvents:PointerEvents}}>
                                {Loader ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>): ('')} Register
                            </button>	

                            <span></span>
                            </div>
                        </div>
                        </form>
                        </div>
        </center>
        

        <div className="col-md-2">
            
        </div>

        
    
</div>
</div>

<Footer />
    </>
);
}   
export default Register;